/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Drawer Open Icon component.
 */
export const FilterDrawerOpenIcon = ({
  color = dlsColor('grey2')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd'
        clipRule='evenodd'
        d='M6.6665 9.92574L7.91095 8.68994L11.9998 12.7504L16.0887 8.68994L17.3332 9.92574L11.9998 15.222L6.6665 9.92574Z'
        fill={iconColor} />
    </svg>
  );
};

export default FilterDrawerOpenIcon;
